import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_STATE_TRANSITION_SAVED = gql`
  subscription documentTypeStateTransitionSaved {
    documentTypeStateTransitionSaved {
      id
      documentTypeId
    }
  }
`;
